import React from 'react';
import { Sparkles, X, ArrowRight } from 'lucide-react';
import { ETHOS_ITEMS } from '../pages/Ethos';

// First-login welcome modal. Greets the user once and previews the Ethos,
// with a link to read the full set on the Ethos page.

export default function EthosWelcome({ userName, onClose, onReadMore }) {
  const firstName = (userName || '').trim().split(' ')[0] || 'there';
  // Preview the first six so the modal stays scannable; full list lives on the page.
  const preview = ETHOS_ITEMS.slice(0, 6);

  return (
    <>
      <div className="ethos-welcome-scrim" onClick={onClose} />
      <div className="ethos-welcome" role="dialog" aria-label="Welcome —  Nativeorange Ethos">
        <button className="ethos-welcome-close" onClick={onClose} aria-label="Close">
          <X size={18} />
        </button>

        <div className="ethos-welcome-header">
          <div className="ethos-welcome-badge"><Sparkles size={18} /></div>
          <span className="ethos-welcome-kicker"> Nativeorange Ethos</span>
          <h2>Hey {firstName}, welcome aboard! 🧡</h2>
          <p>
            We're so glad you're joining us. Before the fun begins, here are a few
            friendly things that make a  Nativeorange event feel like family.
          </p>
        </div>

        <div className="ethos-welcome-list">
          {preview.map((item) => {
            const Icon = item.icon;
            return (
              <div className="ethos-welcome-item" key={item.title}>
                <span className="ethos-welcome-item-icon"><Icon size={16} /></span>
                <div>
                  <strong>{item.title}</strong>
                  <span>{item.text}</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="ethos-welcome-actions">
          <button className="btn btn-secondary" onClick={onReadMore}>
            Read all {ETHOS_ITEMS.length} <ArrowRight size={14} />
          </button>
          <button className="btn btn-primary" onClick={onClose}>
            Got it, let's go!
          </button>
        </div>
      </div>
    </>
  );
}
